import Vue from 'vue'
import Vuex from 'vuex'
import global from './global'
import login from './login/login'
import dashboard from './dashboard/dashboard'
import enquiry from './enquiry/enquiry'
import task from './task/task'
import requisition from './requisition/requisition'

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        global,
        login,
        dashboard,
        enquiry,
        task,
        requisition
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js